import { Grid, Stack, Drawer } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";

import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileRequest } from "services/modules/authenticate";
import setAuthToken from "services/modules/utils/handel_api";
import Header from "./Header";
import SideNavbar from "./SideNavbar";
import { ScrollToTop } from "components/Atoms/SharedComponents/ScrollToTop/ScrollToTop";
import { LayoutId } from "services/modules/utils/constant";

const Layout = ({ notificationUnseenCount }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { currentUserProfile } = useSelector((state) => state?.authenticate);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const action = (data) => {
    currentUserProfile && localStorage.setItem("user_id", data?.data?.user?.id);
  };

  const token = localStorage.getItem("token");

  useEffect(() => {
    setAuthToken(token);
    const requestData = {
      action,
    };
    token && dispatch(getUserProfileRequest({ ...requestData }));
  }, [token]);

  return (
    <Grid
      container
      sx={{
        direction: "row",
        justifyContent: "space-between",
        display: "flex",
      }}
    >
      <Grid item display={{ xs: "none", lg: "grid" }} lg={2.7} xl={2}>
        <SideNavbar />
      </Grid>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: { xs: "280px", sm: "320px" },
          },
        }}
      >
        <SideNavbar onClose={handleDrawerToggle} />
      </Drawer>
      <Grid
        item
        xs={12}
        lg={9.3}
        xl={10}
        sx={{
          backgroundColor: "#F5F5F5",
          overflowY: "scroll",
          height: "100vh",
        }}
        id={LayoutId}
      >
        <ScrollToTop />

        <Header
          notificationUnseenCount={notificationUnseenCount}
          currentUserProfile={currentUserProfile}
          onMenuClick={handleDrawerToggle}
        />
        <Stack p={pathname !== "/messenger" && 3}>
          {pathname !== "/messenger" && <Breadcrumb />}
          <Outlet />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Layout;
